/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DocArrowInIcon24Solid = forwardRef('DocArrowInIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M12.05 2H8a4 4 0 0 0-4 4v10.032a2.25 2.25 0 0 0 2 1.218h1.261a2.75 2.75 0 0 1 4.528-2.338l2.615 2.24A3.752 3.752 0 0 1 15.137 22H16a4 4 0 0 0 4-4v-7.95h-5.2a2.75 2.75 0 0 1-2.75-2.75V2Z" }),
        React.createElement("path", { d: "M20 8.55v-.04l-6.45-6.45V7.3c0 .69.56 1.25 1.25 1.25H20Z" }),
        React.createElement("path", { d: "M1 13a1 1 0 0 1 1 1v1a4 4 0 0 0 4 4h4.797l-1.448-1.24a1 1 0 0 1 1.302-1.52l2.614 2.242a2 2 0 0 1 0 3.037l-2.614 2.24a1 1 0 0 1-1.302-1.518L10.797 21H6a6 6 0 0 1-6-6v-1a1 1 0 0 1 1-1Z" })));
});
